import { Link } from 'react-router-dom';

import useMartyContext from 'hooks/useMartyContext';
import EditIcon from 'components/common/IconsV2/EditIcon';
import SwapIcon from 'components/common/IconsV2/SwapIcon';

import css from 'styles/components/checkout/sectionChangeInline.scss';

const IconMap = {
  edit: (
    <>
      <EditIcon size={24} />
    </>
  ),
  swap: (
    <>
      <SwapIcon size={24} />
    </>
  )
};

const SectionChangeInline = ({ id, label, describedby, testIdName = 'sectionChangeLink', onClickEvent, showLink, to, isInline, icon }) => {
  const { testId } = useMartyContext();

  if (!showLink) {
    return (
      <button aria-describedby={describedby} className={!isInline ? css.changeLink : css.inline} disabled={true} type="button">
        {icon && IconMap[icon]}
        {label}
      </button>
    );
  }

  return (
    <Link
      id={id}
      aria-describedby={describedby}
      className={!isInline ? css.changeLink : css.inline}
      to={to}
      onClick={onClickEvent}
      data-test-id={testId(testIdName)}
    >
      {icon ? IconMap[icon] : label}
    </Link>
  );
};

export default SectionChangeInline;
